export const enum EProfileTabName {
  Personal = 'personal',
  Wallet = 'wallet',
  Security = 'security',
  Orders = 'orders',
}
